<div class="set-budget-modal" *transloco="let t; prefix: 'costTracking.setBudgetModal'">
  <div class="set-budget-modal__header">
    <h3 class="set-budget-modal__title">{{ isEditMode ? t('editTitle') : t('title') }}</h3>
    <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="cancel()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
        </path>
      </svg>
    </button>
  </div>

  <form [formGroup]="budgetForm" class="set-budget-modal__form">
    <div class="form-step">
      @if (isEditMode) {
        <div class="form-group">
          <input
            type="text"
            class="form-control form-control--readonly"
            [value]="editedAssetName"
            [attr.aria-label]="t('vehicleAccount')"
            readonly
            disabled>
        </div>
      } @else {
        <div class="form-group vehicle-account-field">
          <label class="form-label form-label--strong">{{ t('vehicleAccount') }} <span class="required">*</span></label>
          <app-asset-assignment-filter
            [isLoaded]="assetsLoaded"
            [filter]="vehicleFilter"
            [tree]="assetsTree"
            [entityType]="'asset'"
            [labelTitle]="t('selectVehicles')"
            [closeOnOutsideClick]="true"
            [enforceAssignmentRules]="false"
            (driverAssignmentFilterChanged)="onVehicleFilterChanged($event)">
          </app-asset-assignment-filter>
        </div>
      }

      <div class="form-group">
        <label class="form-label">{{ t('budgetCategory') }} <span class="required">*</span></label>
        <div ngbDropdown class="dropdown-wrapper" [autoClose]="true">
          <button type="button" class="form-control dropdown-toggle" [disabled]="isLoadingCategories" ngbDropdownToggle>
            <div class="dropdown-inner">
              <span>{{ categoryLabel }}</span>
              <i class="ph ph-caret-down"></i>
            </div>
          </button>
          <div ngbDropdownMenu class="dropdown-menu">
            @for (category of budgetCategories; track category.id) {
              <button type="button" class="dropdown-item" (click)="onCategorySelect(category)" ngbDropdownItem>
                {{ category.name | lookupLabel:budgetCategoryLabels }}
              </button>
            }
          </div>
        </div>
        @if (categoryConflictMessage) {
          <div class="field-error" role="alert">{{ categoryConflictMessage }}</div>
        }
      </div>

      <div class="form-group">
        <label for="annualBudget" class="form-label">{{ t('annualBudget') }} <span class="required">*</span></label>
        <input
          type="number"
          min="0"
          id="annualBudget"
          formControlName="annualBudget"
          class="form-control"
          [placeholder]="t('enterAmount')">
      </div>

      <div class="form-group">
        <label for="monthlyBudget" class="form-label">{{ t('monthlyBudget') }} <span class="required">*</span></label>
        <input
          type="number"
          min="0"
          id="monthlyBudget"
          formControlName="monthlyBudget"
          class="form-control"
          [placeholder]="t('enterAmount')">
      </div>

      <div class="form-group">
        <label for="notes" class="form-label">{{ t('notesOptional') }}</label>
        <textarea
          id="notes"
          formControlName="notes"
          class="form-control textarea"
          [placeholder]="t('addNotes')"
          rows="3">
        </textarea>
      </div>
    </div>
  </form>

  <div class="budget-alert-info">
    <div class="budget-alert-info__icon">
      <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z" fill="#3873C9"/>
        <path d="M22 12C16.486 12 12 16.486 12 22C12 27.514 16.486 32 22 32C27.514 32 32 27.514 32 22C32 16.486 27.514 12 22 12ZM23 27H21V21H23V27ZM23 19H21V17H23V19Z" fill="white"/>
      </svg>
    </div>
    <div class="budget-alert-info__content">
      <div class="budget-alert-info__title">{{ t('alertTitle') }}</div>
      <div class="budget-alert-info__description">{{ t('alertDescription') }}</div>
    </div>
  </div>

  <div class="set-budget-modal__actions">
    <button type="button" class="btn-cancel" (click)="cancel()">
      <span>{{ 'common.cancel' | transloco }}</span>
    </button>
    <button type="button" class="btn-save" (click)="save()" [disabled]="!isValid || isSaving">
      <span>{{ t('save') }}</span>
    </button>
  </div>
</div>